import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForCheckInBefore_01days = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtCheckInBefore01Days($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtCheckInBefore01Days(input: $input) {
			userErrors
			success
		}
	}
`);
